import { render } from "./ylyProductCreate.vue?vue&type=template&id=e2334a9a&scoped=true"
import script from "./ylyProductCreate.vue?vue&type=script&lang=js"
export * from "./ylyProductCreate.vue?vue&type=script&lang=js"

import "./ylyProductCreate.vue?vue&type=style&index=0&id=e2334a9a&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2334a9a"]])

export default __exports__